/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "eu-west-1",
    "aws_cognito_identity_pool_id": "eu-west-1:31f02392-1adb-4548-b535-f408a2dc5c04",
    "aws_cognito_region": "eu-west-1",
    "aws_user_pools_id": "eu-west-1_50B1xD4wy",
    "aws_user_pools_web_client_id": "3o96kearpf4jdhmcc26kg15uof",
    "oauth": {},
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_appsync_graphqlEndpoint": "https://p4ha4dfeonfrljacx6nkuiscum.appsync-api.eu-west-1.amazonaws.com/graphql",
    "aws_appsync_region": "eu-west-1",
    "aws_appsync_authenticationType": "API_KEY",
    "aws_appsync_apiKey": "da2-3l6euxnkyfcjnbk54tqbt3vk2a",
    "aws_user_files_s3_bucket": "amplify-mvp-dev-storage200824-dev",
    "aws_user_files_s3_bucket_region": "eu-west-1"
};


export default awsmobile;
